module.exports = __webpack_public_path__ + "img/emoji-success-2x.4597258c.png";